var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { eager: "", "max-width": "320" },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _vm._v(
              " " + _vm._s(_vm.$t("hourOverview.buttons.printoutDetail")) + " "
            )
          ]),
          _c(
            "v-card-text",
            [
              _vm.$can("be_timesheet_showPrintWithoutOverhours")
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: {
                        href: _vm.$getBackendUrl(
                          "hours/printtimesheet",
                          Object.assign({}, _vm.printParameters, {
                            hideOverHours: 1
                          })
                        ),
                        target: "_blank",
                        small: ""
                      }
                    },
                    [_vm._v(" Ohne Überstunden ")]
                  )
                : _vm._e(),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: {
                    href: _vm.$getBackendUrl(
                      "hours/printtimesheet",
                      Object.assign({}, _vm.printParameters, { newPage: 1 })
                    ),
                    target: "_blank",
                    small: ""
                  }
                },
                [_vm._v(" Mitarbeiter einzeln ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }